export default "__VITE_ASSET__BtAh$e9w__"